// extracted by mini-css-extract-plugin
export default {"articleonePic":"index_articleonePic_K0rIB","onePicImg":"index_onePicImg_tdofA"};